module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/257e3788c5fbfe56c151a97e97dc20d8.svg";